<template>
  <div>
    <div class="content-header">
      <div class="left">角色管理</div>
      <div class="right">
        <Button
          icon="md-add"
          type="primary"
          @click="EDIT(0)"
          v-if="$CheckShow($route.name,'role_add')"
        >新增角色</Button>
      </div>
    </div>
    <Table border :columns="columns" :data="data">
      <template slot-scope="{ row }" slot="action" fixed="right">
        <Button
          type="primary"
          size="small"
          @click="EDIT(row.id)"
          v-if="$CheckShow($route.name,'role_edit') && row.name !== '超级管理员'"
        >编辑</Button>
      </template>
    </Table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          title: "角色名称",
          key: "name",
        },
        {
          title: "操作",
          slot: "action",
          width: 100,
        },
      ],
      data: [],
    };
  },
  methods: {
    ...mapActions(["GetRoleList"]),
    EDIT(id) {
      this.$router.push({
        name: id ? "role_edit" : "role_add",
        params: { id },
      });
    },
  },
  created() {},
  mounted() {
    this.GetRoleList().then((res) => {
      this.data = res.data;
    });
  },
  computed: mapGetters({
    user_role: "user_role",
  }),
};
</script>

<style lang="less" scoped>
</style>
